import { render, staticRenderFns } from "./ListRegionCourt.vue?vue&type=template&id=6aa0c5d6"
import script from "./ListRegionCourt.vue?vue&type=script&lang=js"
export * from "./ListRegionCourt.vue?vue&type=script&lang=js"
import style0 from "./ListRegionCourt.vue?vue&type=style&index=0&id=6aa0c5d6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports